// Unpublished Work © 2025 Deere & Company.

import {commonErrorAction, ErrorHandlerConfig} from './utils/errorMessages';

export const translationsError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};
